module.exports = __webpack_public_path__ + "img/company-honor-COC-20230718.4b51f40f.jpg";